module.exports = __webpack_public_path__ + "img/BordeauxMetallic_B.58daa327.png";